import { render, staticRenderFns } from "./DashboardTimeline.vue?vue&type=template&id=fb81159a"
import script from "./DashboardTimeline.vue?vue&type=script&lang=js"
export * from "./DashboardTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports